// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"230":"UserHistory-vue","311":"Login-vue","891":"RTL-vue"}[chunkId] + "." + {"230":"55c4e878","311":"356f4ee1","891":"108ddb04"}[chunkId] + ".css";
};